/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Build from the app's connected GitHub repository.
 */
export type DeploymentSourceGit = {
  /**
   * Branch to build (its HEAD). Omit branch and commitSha to use the app's default branch.
   */
  branch?: string | undefined;
  /**
   * Commit to build (full or abbreviated SHA). Takes precedence over branch.
   */
  commitSha?: string | undefined;
  /**
   * Build from a fork instead of the app's connected repository, as "owner/repo". Requires commitSha.
   */
  repository?: string | undefined;
};

/** @internal */
export type DeploymentSourceGit$Outbound = {
  branch?: string | undefined;
  commitSha?: string | undefined;
  repository?: string | undefined;
};

/** @internal */
export const DeploymentSourceGit$outboundSchema: z.ZodType<
  DeploymentSourceGit$Outbound,
  z.ZodTypeDef,
  DeploymentSourceGit
> = z.object({
  branch: z.string().optional(),
  commitSha: z.string().optional(),
  repository: z.string().optional(),
});

export function deploymentSourceGitToJSON(
  deploymentSourceGit: DeploymentSourceGit,
): string {
  return JSON.stringify(
    DeploymentSourceGit$outboundSchema.parse(deploymentSourceGit),
  );
}
